var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RestImportConfig_1;
/* eslint-disable class-methods-use-this */
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { ImportOperation } from '../importTask';
import { ImportConfig, ImportConfigType } from './importConfig';
export const RestBasedImportTypes = [
    // REST based placeholder imports
    ImportConfigType.NetSuite,
    ImportConfigType.SapSuccessFactors,
    ImportConfigType.SapCrm,
    ImportConfigType.Ukg,
    ImportConfigType.OracleHcm,
    ImportConfigType.Adp,
    ImportConfigType.Dynamics365Sales,
    ImportConfigType.CeridianDayforce,
    ImportConfigType.OracleCrm,
    ImportConfigType.OracleErpCloud,
    ImportConfigType.SageIntacct,
    ImportConfigType.BambooHr,
    ImportConfigType.SapErp,
    ImportConfigType.GoogleCloudPlatformCloudStorage,
    ImportConfigType.Sas,
    ImportConfigType.OneDrive,
    ImportConfigType.Dropbox,
    ImportConfigType.GoogleDrive,
    ImportConfigType.Jira,
    ImportConfigType.Monday,
    ImportConfigType.Zuora,
    ImportConfigType.AdobeAnalytics,
    ImportConfigType.ZoomInfo,
    ImportConfigType.Marketo,
    ImportConfigType.ActiveCampaign,
    ImportConfigType.Mailchimp,
    ImportConfigType.Infor,
    ImportConfigType.CornerstoneOnDemand,
    ImportConfigType.Gusto,
    ImportConfigType.PaychexFlex,
    ImportConfigType.Zendesk,
    ImportConfigType.ServiceNow,
    ImportConfigType.ZohoCrm,
    ImportConfigType.Pipedrive,
    ImportConfigType.QuickBooks,
    ImportConfigType.Xero,
    ImportConfigType.Freshbooks,
    ImportConfigType.ZohoBooks,
    ImportConfigType.WaveFinancial
];
const schema = {
    $id: 'urn:wisepipe-common-data:RestImportConfig',
    type: 'object',
    properties: {
        subType: { type: 'string', enum: RestBasedImportTypes }
    },
    required: []
};
let RestImportConfig = RestImportConfig_1 = class RestImportConfig extends ImportConfig {
    constructor(subType, columnsToUpdate) {
        super(ImportConfigType.Rest, columnsToUpdate);
        if (subType)
            this.subType = subType;
        JSON.validate(this, RestImportConfig_1);
    }
    get supportedRefreshOperations() {
        return [ImportOperation.Overwrite];
    }
    get needsDiscovery() {
        return true;
    }
    toSingerConfig(connection, credentials) {
        const restAuth = {
            type: credentials.type,
            user_name: credentials.userName,
            password: credentials.password,
            auth_header: credentials.authHeader,
            refresh_token: credentials.refreshToken,
            client_id: credentials.clientID,
            client_secret: credentials.clientSecret,
            token_url: credentials.tokenUrl,
            token_type: credentials.tokenType,
            key: credentials.key,
            secret: credentials.secret,
            auth_url: credentials.authUrl
        };
        const restEndpoints = {};
        connection.endpoints.forEach((value, key) => {
            restEndpoints[key] = {
                url: value.url,
                verb: value.verb,
                path_to_data: value.pathToData,
                flatten: value.flatten,
                table_key: value.tableKey,
                schema: JSON.serialize(value.schema)
            };
        });
        const pagination = connection.pagination;
        const restPagination = {
            mode: pagination.mode,
            first_page_number: pagination.firstPageNumber,
            last_page: {
                mode: pagination.lastPage?.mode,
                error_code: pagination.lastPage?.errorCode
            },
            request_page_label: pagination.requestPageLabel,
            request_page_size: pagination.requestPageSize,
            request_page_size_label: pagination.requestPageSizeLabel,
            path_to_offset: pagination.pathToOffset,
            offset_label: pagination.offsetLabel,
            cursor_label: pagination.cursorLabel
        };
        return {
            name: connection.name,
            auth: restAuth,
            endpoints: restEndpoints,
            pagination: restPagination
        };
    }
};
RestImportConfig = RestImportConfig_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(ImportConfigType.Rest)
], RestImportConfig);
export { RestImportConfig };
//# sourceMappingURL=restImportConfig.js.map